import { CsvDataHelper } from '@domain/interface/data-map';
import { BROKER_CSV_HEADERS } from '@domain/constants/csv-headers';
import { IS_EMPTY_LINE, MAP_HEADERS } from '../shared/utils';
import { IS_EMPTY, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '@environment/environment';

export const BROKER_DATA_MAP = (formBuilder: UntypedFormBuilder): CsvDataHelper => ({
	headersMap: [
		{ value: BROKER_CSV_HEADERS.BUSINESS_NAME, label: 'Business Name', required: true },
		{ value: BROKER_CSV_HEADERS.MC, label: 'MC', required: false },
		{ value: BROKER_CSV_HEADERS.DOT, label: 'DOT', required: false },
		{ value: BROKER_CSV_HEADERS.CONTACT_NAME, label: 'Contact Name', required: false },
		{ value: BROKER_CSV_HEADERS.PHONE, label: 'Phone', required: false },
		{ value: BROKER_CSV_HEADERS.EMAIL, label: 'Email', required: false },
	],
	requiredHeaders: [BROKER_CSV_HEADERS.BUSINESS_NAME],
	fileDataValidator: (fileHeaders: string, fileData: string[]): string[] => {
		let errors = [];
		let headers = fileHeaders.split(',');
		let headerMap = MAP_HEADERS(headers);

		if (fileData.length > 0) {
			for (var i = 0; i < fileData.length; i++) {
				var line = fileData[i];
				if (IS_EMPTY_LINE(line)) {
					continue;
				}
				var rowElements = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
				if (rowElements.length != headers.length) {
					errors.push(
						`Number of columns required ${headers.length}. Number of columns provided in csv ${rowElements.length}`
					);
					return errors;
				}
				const businessName = rowElements[headerMap[BROKER_CSV_HEADERS.BUSINESS_NAME]],
					mc = rowElements[headerMap[BROKER_CSV_HEADERS.MC]],
					dot = rowElements[headerMap[BROKER_CSV_HEADERS.DOT]];

				if (IS_NULL_OR_UNDEFINED(businessName) || IS_EMPTY(businessName)) {
					errors.push('Business Name is required.');
				}
				if (
					(IS_NULL_OR_UNDEFINED(mc) || IS_EMPTY(mc)) &&
					(IS_NULL_OR_UNDEFINED(dot) || IS_EMPTY(dot))
				) {
					errors.push('MC or DOT is required.');
				}
				break;
			}
		} else {
			errors.push('No record found.');
		}

		return errors;
	},
	formGroupBuilder: (): UntypedFormGroup => {
		let form: UntypedFormGroup;
		form = formBuilder.group({
			[BROKER_CSV_HEADERS.BUSINESS_NAME]: ['', Validators.required],
			[BROKER_CSV_HEADERS.MC]: [''],
			[BROKER_CSV_HEADERS.DOT]: [''],
			[BROKER_CSV_HEADERS.CONTACT_NAME]: [''],
			[BROKER_CSV_HEADERS.PHONE]: [''],
			[BROKER_CSV_HEADERS.EMAIL]: [''],
		});
		return form;
	},
	fileUploadBucketName: environment.BULK_MATCH_CONFIG.broker.bucketName,
});
